(() => {
  const selector = '.product__description .bundle-track-list[data-bundle-track-key]';

  class BundleTrackListController {
    constructor(picker) {
      this.picker = picker;
      this.productInfo = picker.closest('product-info');
      this.description = this.productInfo?.querySelector('.product__description');
      this.details = this.description ? Array.from(this.description.querySelectorAll(selector)) : [];
      this.variants = this.readVariants();

      if (!this.description || !this.details.length || !this.variants.length) return;

      this.description.classList.add('bundle-track-list-enabled');
      this.description.setAttribute('aria-live', 'polite');
      this.picker.addEventListener('change', () => queueMicrotask(() => this.update()));
      this.update();
    }

    readVariants() {
      const data = this.picker.querySelector('script[type="application/json"]');
      if (!data) return [];

      try {
        return JSON.parse(data.textContent);
      } catch (error) {
        return [];
      }
    }

    selectedValues() {
      return Array.from(this.picker.querySelectorAll('select, fieldset')).map((element) => {
        if (element.tagName === 'SELECT') return element.value;
        return element.querySelector('input:checked')?.value;
      });
    }

    selectedVariant() {
      if (this.picker.currentVariant) return this.picker.currentVariant;

      const variantId = new URL(window.location.href).searchParams.get('variant');
      if (variantId) {
        const fromUrl = this.variants.find((variant) => String(variant.id) === variantId);
        if (fromUrl) return fromUrl;
      }

      const values = this.selectedValues();
      return this.variants.find((variant) =>
        variant.options.every((value, index) => value === values[index])
      );
    }

    update() {
      const variant = this.selectedVariant();
      let activeIndex = this.variants.findIndex((item) => item.id === variant?.id);

      if (activeIndex < 0 || activeIndex >= this.details.length) activeIndex = 0;

      this.details.forEach((detail, index) => {
        const active = index === activeIndex;
        detail.hidden = !active;
        detail.open = active;
        detail.setAttribute('aria-hidden', String(!active));
      });

      this.description.dataset.activeBundleTrackKey = this.details[activeIndex]?.dataset.bundleTrackKey || '';
    }
  }

  const initialize = (root = document) => {
    root.querySelectorAll('variant-selects').forEach((picker) => {
      if (picker.dataset.bundleTrackListReady === 'true') return;
      if (!picker.closest('product-info')?.querySelector(selector)) return;

      picker.dataset.bundleTrackListReady = 'true';
      new BundleTrackListController(picker);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
